import { type Route } from '@/types/route'

import { filterRoutesWithPermissions } from './filterRoutesWithPermissions'

export const getFirstPossibleRoute = (routes: Route[]) =>
  filterRoutesWithPermissions(routes)[0]
